import * as yup from "yup";
import { Vocabulary } from "./Vocabulary";

/**
 * Validation schema for Service Document/Contract form
 */
export const ServiceDocumentValidationSchema = yup.object().shape({
  contractDate: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .test(
      "is-valid-date",
      Vocabulary.invalidDate || "Invalid date format",
      (value) => {
        if (!value) return false;
        // Check if it's a valid date format (Romanian format: DD.MM.YYYY or DD/MM/YYYY)
        const dateRegex = /^(\d{1,2})[./](\d{1,2})[./](\d{4})$/;
        return dateRegex.test(value);
      }
    ),
  providerCompany: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .min(3, Vocabulary.minLength?.replace("{0}", "3") || "Minimum 3 characters"),
  providerAddress: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .min(10, Vocabulary.minLength?.replace("{0}", "10") || "Minimum 10 characters"),
  providerCUI: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .matches(
      /^RO?\d{2,10}$/i,
      Vocabulary.invalidCUI || "Invalid CUI format (e.g., RO12345678)"
    ),
  providerJ: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .matches(
      /^J\d{1,2}\/\d{1,5}\/\d{4}$/,
      Vocabulary.invalidJ || "Invalid J format (e.g., J33/379/2012)"
    ),
  providerRepresentative: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .min(3, Vocabulary.minLength?.replace("{0}", "3") || "Minimum 3 characters"),
  clientName: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .min(3, Vocabulary.minLength?.replace("{0}", "3") || "Minimum 3 characters"),
  clientAddress: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .min(10, Vocabulary.minLength?.replace("{0}", "10") || "Minimum 10 characters"),
  clientCNP: yup
    .string()
    .required(Vocabulary.fieldRequired || "This field is required")
    .matches(
      /^\d{13}$/,
      Vocabulary.invalidCNP || "CNP must be exactly 13 digits"
    ),
});

export type ServiceDocumentFormData = yup.InferType<typeof ServiceDocumentValidationSchema>;
